export interface ISharedProps {
    dataTab: any;
    sharedData?: any;
    rentings?: any;
}

export interface IMyPropsMobiles {
    dataMobiles: any;
}

export interface ErrorStateUIData {
    title: string;
    localizedDescription?: string;
    id?: string | null | undefined;
    httpCode?: number | string;
}

export type IValidations = {
    phone: RegExp;
};

export enum EValidations {
    phone = 'phone',
}

export const validationsRegExp: IValidations = {
    phone: /(^[9|6|7])[0-9]{8}/,
};

export type IMisticaDropdownOptions = {
    text: string;
    value: string;
    data?: any;
};
